import { render, staticRenderFns } from "./business.md?vue&type=template&id=c08748fc&"
import script from "./business.md?vue&type=script&lang=js&"
export * from "./business.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports